<template>
    <v-layout>
        <!-- data-and-stats -->
        <v-sheet v-if="type === 'data-and-stats' || type === 'cindex' || type === undefined" class="overflow-hidden"
            style="background: transparent">

            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="onAddStatistic">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}ข้อมูลแสดงกราฟ
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.title_th" solo flat>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.title_en" solo flat>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด TH :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler v-model="statisticForm.description_th"
                                        @image-added="handleImageAdded"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด EN :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler v-model="statisticForm.description_en"
                                        @image-added="handleImageAdded"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Caption TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.caption_th" solo flat>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Caption EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.caption_en" solo flat>
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ข้อมูล :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="statisticForm.topic_id" :items="topicOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" solo flat item-color="#FF4F23"
                                        color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รูปแบบกราฟ :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="statisticForm.graph_type_id" :items="graphTypes" item-text="name"
                                        item-value="id" item-color="" color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-3 mr-4>-->
                            <!--                                    ข้อมูลที่จะแสดง :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs8>-->
                            <!--                                    <v-select-->
                            <!--                                            color="#FF4F23"-->
                            <!--                                            solo-->
                            <!--                                            flat-->
                            <!--                                    ></v-select>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-3 mr-4>-->
                            <!--                                    ตัวชี้วัด :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs8>-->
                            <!--                                    <v-select-->
                            <!--                                            v-model="statisticForm.index_id"-->
                            <!--                                            :items="indexOption"-->
                            <!--                                            item-text="text"-->
                            <!--                                            item-value="id"-->
                            <!--                                            :menu-props="{ offsetY: true }"-->
                            <!--                                            solo-->
                            <!--                                            flat-->
                            <!--                                            item-color="#FF4F23"-->
                            <!--                                            color="#FF4F23"-->
                            <!--                                    ></v-select>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    # Tag :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="statisticForm.tags" :items="tagOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" chips multiple deletable-chips
                                        solo flat item-color="#FF4F23" color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อแหล่งข้อมูล (Thai) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.reference_text_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อแหล่งข้อมูล (Eng) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.reference_text_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    แหล่งข้อมูล (link) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.link_data_url" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex shrink pt-3 mr-4>
                                    แสดงผลทุกปี :
                                </v-flex>
                                <v-flex xs8>
                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_show_data_all_year"
                                                :true-value="1" :false-value="0" label="แสดงผลทุกปี"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex shrink pt-3 mr-4>
                                    ซ่อนการแสดงผลตาราง :
                                </v-flex>
                                <v-flex xs8>
                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_hide_detail_table"
                                                :true-value="1" :false-value="0"
                                                label="ซ่อนการแสดงผลตาราง"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex pt-5 mr-4 shrink>
                                    การแสดงผล :
                                </v-flex>
                                <v-flex>
                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_display_overview"
                                                :true-value="1" :false-value="0"
                                                label="แสดงผลในหน้า Overview"></v-checkbox>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex style="max-width: 290px">
                                            <v-text-field solo flat label="ตำแหน่ง"
                                                v-model="statisticForm.ordering_overview"
                                                :disabled="!statisticForm.is_display_overview"></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_display_industry"
                                                :true-value="1" :false-value="0"
                                                label="แสดงผลในหน้า Industry"></v-checkbox>
                                            <div>
                                                <v-select v-model="statisticForm.industries" :items="industryOption"
                                                    item-text="text_th" item-value="id"
                                                    :disabled="!statisticForm.is_display_industry" item-color="#FF4F23"
                                                    color="#FF4F23" chips multiple deletable-chips solo flat></v-select>
                                            </div>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex style="max-width: 290px">
                                            <v-text-field solo flat label="ตำแหน่ง"
                                                v-model="statisticForm.ordering_industry"
                                                :disabled="!statisticForm.is_display_industry"></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_display_index"
                                                :true-value="1" :false-value="0"
                                                label="แสดงผลในหน้า Creativity Index"></v-checkbox>
                                        </v-flex>
                                        <v-spacer></v-spacer>
                                        <v-flex style="max-width: 290px">
                                            <v-text-field solo flat label="ตำแหน่ง"
                                                v-model="statisticForm.ordering_index"
                                                :disabled="!statisticForm.is_display_index"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <Preview :data="statisticForm" :disabled="hasDataStatForm ? false : true"></Preview>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- report -->
        <v-sheet v-else-if="type === 'report'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}ข้อมูลแสดงรายงาน / วิจัย
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อรายงาน TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="articleData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อรายงาน EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="articleData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Intro TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="articleData.intro_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Intro EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="articleData.intro_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด TH :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"
                                        v-model="articleData.detail_th"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด EN :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"
                                        v-model="articleData.detail_en"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    วันที่รายงาน :
                                </v-flex>
                                <v-flex xs8>
                                    <v-layout>
                                        <v-flex xs6 pr-2>
                                            <v-menu v-model="dateDialog" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-model="articleData.split_date" append-icon="event"
                                                        color="#FF4F23" solo flat readonly v-on="on"></v-text-field>
                                                </template>
                                                <v-date-picker color="#FF4F23" v-model="articleData.split_date"
                                                    locale="th"></v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex xs6 pl-2>
                                            <v-menu v-model="timeDialog" :close-on-content-click="false"
                                                :nudge-right="40" transition="scale-transition" offset-y
                                                min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-model="articleData.split_time"
                                                        append-icon="schedule" color="#FF4F23" solo flat readonly
                                                        v-on="on"></v-text-field>
                                                </template>
                                                <v-time-picker color="#FF4F23" v-model="articleData.split_time"
                                                    format="24hr" locale="th"></v-time-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ตัวชี้วัด :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="articleData.indexmanage_id" :items="indexOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" solo flat item-color="#FF4F23"
                                        color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    กลุ่มอุตสาหกรรมสร้างสรรค์ :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="articleData.industry_id" :items="industryOption"
                                        item-text="text_th" item-value="id" :menu-props="{ offsetY: true }" solo flat
                                        item-color="#FF4F23" color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รูปภาพรายงาน :
                                </v-flex>
                                <v-flex xs8>
                                    <v-file-input @change="reportImageAdded" v-model="fileInput" prepend-icon
                                        label="ขนาดรูปที่แนะนำ 750x750" show-size color="#FF4F23"
                                        accept="image/png, image/jpeg, image/bmp" append-icon="camera_alt" solo flat
                                        clear></v-file-input>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end v-if="edit" mb-5>
                                <v-flex shrink pt-3 mr-4>
                                    <!-- leave it blank -->
                                </v-flex>
                                <v-flex xs8>
                                    <v-img v-if="articleData.image_cover_path !== ''"
                                        :src="http + '/' + articleData.image_cover_path" max-width="150"
                                        max-height="150"></v-img>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รูปภาพปกสำหรับการแชร์ :
                                </v-flex>
                                <v-flex xs8>
                                    <v-file-input @change="reportShareImageAdded" v-model="shareImgInput" prepend-icon
                                        label="ขนาดรูปที่แนะนำ 1200x630" show-size color="#FF4F23"
                                        accept="image/png, image/jpeg, image/bmp" append-icon="camera_alt" solo flat
                                        clear></v-file-input>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end v-if="edit" mb-5>
                                <v-flex shrink pt-3 mr-4>
                                    <!-- leave it blank -->
                                </v-flex>
                                <v-flex xs8>
                                    <v-img v-if="articleData.image_share_path !== ''"
                                        :src="http + '/' + articleData.image_share_path" max-width="150"
                                        max-height="150"></v-img>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    # Tag :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select v-model="articleData.tag_id" :items="tagOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" chips multiple deletable-chips
                                        solo flat item-color="#FF4F23" color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex pt-5 mr-4 shrink>
                                    การแสดงผล :
                                </v-flex>
                                <v-flex xs8>
                                    <v-checkbox color="#FF4F23" v-model="articleData.is_display_overview"
                                        :true-value="1" :false-value="0" label="แสดงผลในหน้า Overview"></v-checkbox>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <!--                                <v-btn large color="#4F4F4F" class="mr-5 white&#45;&#45;text">แสดงตัวอย่าง</v-btn>-->
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- cindex -->
        <v-sheet v-else-if="type === 'cindex'" class="overflow-hidden" style="background: transparent">

            <v-btn depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}ข้อมูลแสดงกราฟ
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด TH :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รายละเอียด EN :
                                </v-flex>
                                <v-flex xs8 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Caption TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    Caption EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ประเภทข้อมูล :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รูปแบบกราฟ :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ข้อมูลที่จะแสดง :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ตัวชี้วัด :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    # Tag :
                                </v-flex>
                                <v-flex xs8>
                                    <v-select color="#FF4F23" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    https:// :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อแหล่งข้อมูล (Thai) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.reference_text_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อแหล่งข้อมูล (Eng) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.reference_text_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    แหล่งข้อมูล (link) :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="statisticForm.link_data_url" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex shrink pt-3 mr-4>
                                    แสดงผลทุกปี :
                                </v-flex>
                                <v-flex xs8>
                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_show_data_all_year"
                                                :true-value="1" :false-value="0" label="แสดงผลทุกปี"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <v-layout>
                                <v-flex shrink pt-3 mr-4>
                                    ซ่อนการแสดงผลตาราง :
                                </v-flex>
                                <v-flex xs8>
                                    <v-layout align-baseline>
                                        <v-flex>
                                            <v-checkbox color="#FF4F23" v-model="statisticForm.is_hide_detail_table"
                                                :true-value="1" :false-value="0"
                                                label="ซ่อนการแสดงผลตาราง"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <!--                                <v-btn large color="#4F4F4F" class="mr-5 white&#45;&#45;text">แสดงตัวอย่าง</v-btn>-->
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- tsic -->
        <v-sheet v-else-if="type === 'tsic'" class="overflow-hidden" style="background: transparent">

            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}กิจกรรมทางเศรษฐกิจ
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    รหัสกิจกรรมทางเศรษฐกิจ :
                                </v-flex>
                                <v-flex xs8>
                                    <v-text-field v-model="tsicData.code" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกิจกรรมทางเศรษฐกิจ TH :
                                </v-flex>
                                <v-flex xs8>
                                    <v-textarea v-model="tsicData.name_th" auto-grow solo flat></v-textarea>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกิจกรรมทางเศรษฐกิจ EN :
                                </v-flex>
                                <v-flex xs8>
                                    <v-textarea v-model="tsicData.name_en" auto-grow solo flat></v-textarea>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- group -->
        <v-sheet v-else-if="type === 'group'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}กลุ่มอุตสาหกรรมสร้างสรรค์
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มอุตสาหกรรมสร้างสรรค์ TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="groupData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มอุตสาหกรรมสร้างสรรค์ EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="groupData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รหัสกิจกรรมทางเศรษฐกิจ :
                                </v-flex>
                                <v-flex xs7>
                                    <v-select v-model="groupData.industry_tsic" :items="tsicOption" item-text="text"
                                        item-value="tsic_id" chips multiple deletable-chips
                                        :menu-props="{ offsetY: true }" solo flat item-color="#FF4F23"
                                        color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    คำอธิบายอุตสาหกรรม TH :
                                </v-flex>
                                <v-flex xs7 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"
                                        v-model="groupData.description_th"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    คำอธิบายอุตสาหกรรม EN :
                                </v-flex>
                                <v-flex xs7 mb-7>
                                    <VueEditor useCustomImageHandler @image-added="handleImageAdded"
                                        v-model="groupData.description_en"></VueEditor>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รูปไอคอน :
                                </v-flex>
                                <v-flex xs7>
                                    <v-file-input @change="industryImageAdded" v-model="iconFileInput" prepend-icon
                                        label="ขนาดรูปที่แนะนำ 150x150" show-size color="#FF4F23"
                                        accept="image/png, image/jpeg, image/ico" append-icon="camera_alt" solo flat
                                        clear></v-file-input>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end v-if="edit" mb-5>
                                <v-flex shrink pt-3 mr-4>
                                    <!-- leave it blank -->
                                </v-flex>
                                <v-flex xs7>
                                    <v-img v-if="groupData.icon_path !== ''" :src="http + '/' + groupData.icon_path"
                                        max-width="150" max-height="150"></v-img>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-5 mr-4>
                                    สถานะการแสดงข้อมูล :
                                </v-flex>
                                <v-flex xs7>
                                    <v-radio-group row v-model="groupData.status">
                                        <v-radio color="#FF4F23" label="Active" :value="1"></v-radio>
                                        <v-radio color="#FF4F23" label="Inactive" :value="0"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- jobs -->
        <v-sheet v-else-if="type === 'jobs'" class="overflow-hidden" style="background: transparent">

            <v-btn depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}อาชีพสร้างสรรค์
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <!-- TODO -->

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- jobs-group -->
        <v-sheet v-else-if="type === 'jobs-group'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head" style="color: #FF4F23">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}กลุ่มอาชีพสร้างสรรค์
                                </v-flex>
                            </v-layout>

                            <div class="my-3" style="border-bottom: solid 2px #FF4F23"></div>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มอาชีพสร้างสรรค์ TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="jobsGroup.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มอาชีพสร้างสรรค์ EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="jobsGroup.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-3 mr-4>-->
                            <!--                                    Caption TH :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs7>-->
                            <!--                                    <v-text-field-->
                            <!--                                            solo-->
                            <!--                                            flat-->
                            <!--                                    ></v-text-field>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-3 mr-4>-->
                            <!--                                    Caption EN :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs7>-->
                            <!--                                    <v-text-field-->
                            <!--                                            solo-->
                            <!--                                            flat-->
                            <!--                                    ></v-text-field>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-3 mr-4>-->
                            <!--                                    อาชีพสร้างสรรค์ :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs7>-->
                            <!--                                    <v-select-->
                            <!--                                            :items="jobs"-->
                            <!--                                            chips-->
                            <!--                                            multiple-->
                            <!--                                            deletable-chips-->
                            <!--                                            :menu-props="{ offsetY: true }"-->
                            <!--                                            solo-->
                            <!--                                            flat-->
                            <!--                                            item-color="#FF4F23"-->
                            <!--                                            color="#FF4F23"-->
                            <!--                                    ></v-select>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <div class="my-3" style="border-bottom: solid 2px #FF4F23"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- index -->
        <v-sheet v-else-if="type === 'index'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}ตัวชี้วัด
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    รหัสตัวชี้วัด :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="indexData.index_code" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อตัวชี้วัด TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="indexData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อตัวชี้วัด EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="indexData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    หน่วย :
                                </v-flex>
                                <v-flex xs7>
                                    <!-- Leave item-color blank, already set in styles.scss -->
                                    <v-select v-model="indexData.unit_id" :items="unitOption" item-text="text_th"
                                        item-value="unit_id" item-color="" solo flat></v-select>
                                </v-flex>
                            </v-layout>

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-5 mr-4>-->
                            <!--                                    สถานะ :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs7>-->
                            <!--                                    <v-radio-group row>-->
                            <!--                                        <v-radio color="#FF4F23" label="ใช้งาน"></v-radio>-->
                            <!--                                        <v-radio color="#FF4F23" label="ไม่ใช้งาน"></v-radio>-->
                            <!--                                    </v-radio-group>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- index-group -->
        <v-sheet v-else-if="type === 'index-group'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}กลุ่มตัวชี้วัด
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มตัวชี้วัด TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="indexGroupData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อกลุ่มตัวชี้วัด EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="indexGroupData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ตัวชี้วัด :
                                </v-flex>
                                <v-flex xs7>
                                    <v-select v-model="indexGroupData.group_index" :items="indexOption" item-text="text"
                                        item-value="id" chips multiple deletable-chips :menu-props="{ offsetY: true }"
                                        solo flat item-color="#FF4F23" color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- title -->
        <v-sheet v-else-if="type === 'title'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}หัวข้อการนำเข้าข้อมูล
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="topicData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหัวข้อ EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="topicData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- import -->
        <v-sheet v-else-if="type === 'import'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}การนำเข้าข้อมูลด้วยไฟล์ Excel
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อ :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="importedData.name" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    เลือกหัวข้อ :
                                </v-flex>
                                <v-flex xs7>
                                    <v-select v-model="importedData.topic_id" :items="topicOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" solo flat item-color="#FF4F23"
                                        color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ตัวชี้วัด :
                                </v-flex>
                                <v-flex xs7>
                                    <v-select v-model="importedData.index_id" :items="indexOption" item-text="text"
                                        item-value="id" :menu-props="{ offsetY: true }" solo flat item-color="#FF4F23"
                                        color="#FF4F23"></v-select>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ปี :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="importedData.year_data" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <!--                            <v-layout justify-end>-->
                            <!--                                <v-flex shrink pt-5 mr-4>-->
                            <!--                                    สถานะการใช้งาน :-->
                            <!--                                </v-flex>-->
                            <!--                                <v-flex xs7>-->
                            <!--                                    <v-radio-group row>-->
                            <!--                                        <v-radio color="#FF4F23" label="ใช้งาน"></v-radio>-->
                            <!--                                        <v-radio color="#FF4F23" label="ไม่ใช้งาน"></v-radio>-->
                            <!--                                    </v-radio-group>-->
                            <!--                                </v-flex>-->
                            <!--                            </v-layout>-->

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ไฟล์แนบ :
                                </v-flex>
                                <v-flex xs7>
                                    <v-file-input v-model="importedData.file_path" prepend-icon
                                        append-icon="attach_file" color="#FF4F23" show-size solo flat
                                        clear></v-file-input>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- unit -->
        <v-sheet v-else-if="type === 'unit'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}หน่วยของข้อมูล
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหน่วย TH :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="unitData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อหน่วย EN :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="unitData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- tag -->
        <v-sheet v-else-if="type === 'tag'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>

            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>

            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }} Tag
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    #Tag :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="tagData.name" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>


                        </v-layout>
                    </v-flex>
                </v-layout>

            </v-navigation-drawer>
        </v-sheet>

        <!-- users -->
        <v-sheet v-else-if="type === 'users'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>
            <v-btn v-else depressed large color="#FF4F23" class="pr-7 text-start white--text titleHeader"
                @click.stop="drawer = !drawer">
                <v-icon class="mr-2">add</v-icon>
                เพิ่ม
            </v-btn>
            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>

                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    {{ edit === true ? 'แก้ไข' : 'เพิ่ม' }}ผู้ใช้งานระบบ
                                </v-flex>
                            </v-layout>

                            <div class="my-3 cea-underline"></div>

                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อจริง :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="userAccount.first_name" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    นามสกุล :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="userAccount.last_name" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end v-if="!edit">
                                <v-flex shrink pt-3 mr-4>
                                    อีเมล :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="userAccount.email" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อผู้ใช้งาน :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="userAccount.username" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout justify-end v-if="edit">
                                <v-flex v-if="changePass">
                                    <v-layout justify-end>
                                        <v-flex shrink cea-color>
                                            <span style="cursor: pointer"
                                                @click="changePass = false">ยกเลิกเปลี่ยนรหัสผ่าน</span>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout justify-end>
                                        <v-flex shrink pt-3 mr-4>
                                            รหัสผ่าน :
                                        </v-flex>
                                        <v-flex xs7>
                                            <v-text-field v-model="userAccount.password" type="password" solo
                                                flat></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout justify-end>
                                        <v-flex shrink pt-3 mr-4>
                                            ยืนยันรหัสผ่าน :
                                        </v-flex>
                                        <v-flex xs7>
                                            <v-text-field v-model="userAccount.c_password" type="password" solo
                                                flat></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex v-else shrink cea-color>
                                    <span style="cursor: pointer" @click="changePass = true">เปลี่ยนรหัสผ่าน...</span>
                                </v-flex>
                            </v-layout>

                            <div v-else>
                                <v-layout justify-end>
                                    <v-flex shrink pt-3 mr-4>
                                        รหัสผ่าน :
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-text-field v-model="userAccount.password" type="password" solo
                                            flat></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout justify-end>
                                    <v-flex shrink pt-3 mr-4>
                                        ยืนยันรหัสผ่าน :
                                    </v-flex>
                                    <v-flex xs7>
                                        <v-text-field v-model="userAccount.c_password" type="password" solo
                                            flat></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </div>

                            <div class="my-3 cea-underline"></div>
                            <v-layout justify-end my-5>
                                <v-btn large color="#8A8A8A" class="mr-5 white--text" v-if="edit"
                                    @click="onDelete">ลบ</v-btn>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-navigation-drawer>
        </v-sheet>

        <v-sheet v-else-if="type === 'main-menu'" class="overflow-hidden" style="background: transparent">
            <v-icon v-if="edit" color="#FF4F23" @click="onEdit(param, userData.token)">edit</v-icon>
            <v-navigation-drawer v-model="drawer" absolute style="position: fixed"
                :width="$vuetify.breakpoint.mdAndUp ? '65%' : '90%'" temporary right>
                <v-layout pa-3>
                    <v-flex shrink mr-12>
                        <v-btn fab small depressed @click.stop="drawer = !drawer"
                            style="background-color: transparent; position: fixed">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex mr-7>
                        <v-layout column>
                            <v-layout justify-start mt-4>
                                <v-flex shrink class="txt-head cea-color">
                                    แก้ไขเมนูหลัก
                                </v-flex>
                            </v-layout>
                            <div class="my-3 cea-underline"></div>
                            <v-layout justify-end pt-3>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่อไทย :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="mainMenuData.name_th" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-3 mr-4>
                                    ชื่ออังกฤษ :
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field v-model="mainMenuData.name_en" solo flat></v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout justify-end>
                                <v-flex shrink pt-5 mr-4>
                                    สถานะการแสดงข้อมูล :
                                </v-flex>
                                <v-flex xs7>
                                    <v-radio-group row v-model="mainMenuData.status">
                                        <v-radio color="#FF4F23" label="Active" :value="1"></v-radio>
                                        <v-radio color="#FF4F23" label="Inactive" :value="0"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                            </v-layout>
                            <div class="my-3 cea-underline"></div>
                            <v-layout justify-end my-5>
                                <v-btn large color="#FF4F23" class="white--text" @click="saveForm">บันทึก</v-btn>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-navigation-drawer>
        </v-sheet>

    </v-layout>
</template>

<script>
import { VueEditor } from "vue2-editor"
import { mapState, mapGetters, mapActions } from 'vuex'
import Preview from "./Preview"
import { domain } from "../services/Constants"
import axios from 'axios'
import Swal from "sweetalert2";

export default {
    name: "InputForm",
    components: {
        Preview,
        VueEditor
    },
    props: ['type', 'edit', 'param'],
    data: () => ({
        fileInput: null,
        shareImgInput: null,
        iconFileInput: null,
        drawer: null,
        timeDialog: false,
        dateDialog: false,
        jobs: [],
        changePass: false,
        http: domain,
        tsicData: {
            code: '',
            name_th: '',
            name_en: ''
        },
        groupData: {
            name_th: '',
            name_en: '',
            industry_tsic: [],
            description_th: '',
            description_en: '',
            icon_path: '',
            icon: '',
            status: 0
        },
        jobsGroup: {
            name_th: '',
            name_en: ''
        },
        unitData: {
            name_th: '',
            name_en: ''
        },
        indexData: {
            index_code: '',
            name_th: '',
            name_en: '',
            unit_id: null
        },
        indexGroupData: {
            name_th: '',
            name_en: '',
            group_index: []
        },
        userAccount: {
            first_name: '',
            last_name: '',
            email: '',
            username: '',
            password: '',
            c_password: ''
        },
        articleData: {
            name_th: '',
            name_en: '',
            intro_th: '',
            intro_en: '',
            detail_th: '',
            detail_en: '',
            report_create_date: '',
            split_date: new Date().toISOString().substr(0, 10),
            split_time: new Date().toTimeString().substr(0, 5),
            indexmanage_id: null,
            tag_id: [],
            industry_id: null,
            image_cover_path: '',
            image_share_path: '',
            is_display_overview: 0
        },
        tagData: {
            name: ''
        },
        topicData: {
            name_th: '',
            name_en: ''
        },
        importedData: {
            topic_id: null,
            index_id: null,
            year_data: null,
            file_path: null,
            display_status: 0,
            name: ''
        },
        mainMenuData: {
            id: null,
            name_th: '',
            name_en: '',
            src_url: '',
            status: 0,
        },
    }),
    computed: {
        ...mapState({
            userData: state => state.auth.userData,
            tsicForm: state => state.tsic.tsicForm,
            industryForm: state => state.tsic.industryForm,
            jobsGroupForm: state => state.job.jobsGroupForm,
            unitForm: state => state.data.unitForm,
            indexForm: state => state.index.indexForm,
            indexGroupForm: state => state.index.indexGroupForm,
            articleForm: state => state.dashboard.articleForm,
            accountForm: state => state.auth.accountForm,
            tagForm: state => state.data.tagForm,
            topicForm: state => state.data.topicForm,
            graphTypes: state => state.graphType.graphTypes,
            statisticForm: state => state.statistic.statisticForm,
            mainMenuForm: state => state.data.mainMenuForm

        }),
        ...mapGetters({
            indexOption: 'index/indexOption',
            tagOption: 'data/tagOption',
            industryOption: 'tsic/industryOption',
            tsicOption: 'tsic/tsicOption',
            unitOption: 'data/unitOption',
            topicOption: 'data/topicOption',
            nameOption: 'data/nameOption'
        }),
        hasDataStatForm: function () {
            if (this.statisticForm.title_th === '' || this.statisticForm.latestyear === null || this.statisticForm.graph === null || this.statisticForm.graph_type_id === null) {
                return false
            } else {
                return true
            }
        },
        // watchValue: function () {
        //     // let val = { industry: this.statisticForm.industries, tags: this.statisticForm.tags };
        //     // return val
        //     return this.articleData
        // },
        // changingValue: function () {
        //     // let val = { industry: this.statisticForm.industries, tags: this.statisticForm.tags };
        //     // return val
        //     return this.type
        // }
    },
    methods: {
        ...mapActions('tsic',
            [
                'onGetAllTsicPaginate', 'onGetTsic', 'onCreateTsic', 'onEditTsic', 'onDeleteTsic',
                'onGetAllIndustriesPaginate', 'onGetIndustry', 'onCreateIndustry', 'onEditIndustry', 'onDeleteIndustry'
            ]),
        ...mapActions('job',
            [
                'onGetAllJobsGroupPaginate', 'onGetJobsGroup', 'onCreateJobsGroup', 'onEditJobsGroup', 'onDeleteJobsGroup'
            ]),
        ...mapActions('data',
            [
                'onGetAllUnitPaginate', 'onGetUnit', 'onCreateUnit', 'onEditUnit', 'onDeleteUnit',
                'onGetAllTagPaginate', 'onGetTag', 'onCreateTag', 'onEditTag', 'onDeleteTag',
                'onGetAllTopicPaginate', 'onGetTopic', 'onCreateTopic', 'onEditTopic', 'onDeleteTopic',
                'onGetAllImportedPaginate', 'onGetImported', 'onCreateImported', 'onEditImported', 'onDeleteImported',
                'onGetAllMainMenu', 'onGetMainMenu', 'onEditMainMenu'
            ]),
        ...mapActions('index',
            [
                'onGetAllIndexPaginate', 'onGetIndex', 'onCreateIndex', 'onEditIndex', 'onDeleteIndex',
                'onGetAllIndexGroupPaginate', 'onGetIndexGroup', 'onCreateIndexGroup', 'onEditIndexGroup', 'onDeleteIndexGroup',
            ]),
        ...mapActions('auth',
            [
                'onGetAllAccountPaginate', 'onGetAccount', 'onCreateAccount', 'onEditAccount', 'onDeleteAccount'
            ]),
        ...mapActions('dashboard',
            [
                'onGetAllArticlePaginate', 'onGetArticle', 'onCreateArticle', 'onEditArticle', 'onDeleteArticle'
            ]),
        ...mapActions('statistic',
            [
                'populateStatistics', 'populateStatisticForm', 'clearStatisticForm', 'saveStatisticForm', 'onDeleteStatistic'
            ]),
        ...mapActions('graphType',
            [
                'populateGraphTypes'
            ]),
        // open dialog (not save form button)
        async onEdit(id, token) {
            let data = { id: id, token: token };
            switch (this.type) {
                case 'tsic':
                    this.onGetTsic(data).then(() => {
                        this.tsicData = {
                            code: this.tsicForm.tsic_code,
                            name_th: this.tsicForm.tsic_name_th,
                            name_en: this.tsicForm.tsic_name_en
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'group':
                    const industryTsicArray = [];
                    this.onGetIndustry(data).then(() => {
                        this.industryForm.industry_tsic.forEach((item) => {
                            industryTsicArray.push(item.tsic_id)
                        });
                        this.groupData = {
                            name_th: this.industryForm.name_th,
                            name_en: this.industryForm.name_en,
                            industry_tsic: industryTsicArray,
                            description_th: this.industryForm.description_th,
                            description_en: this.industryForm.description_en,
                            icon_path: this.industryForm.icon_path,
                            status: this.industryForm.status
                        };
                        this.iconFileInput = null;
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'jobs-group':
                    this.onGetJobsGroup(data).then(() => {
                        this.jobsGroup = {
                            name_th: this.jobsGroupForm.name_th,
                            name_en: this.jobsGroupForm.name_en
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'unit':
                    this.onGetUnit(data).then(() => {
                        this.unitData = {
                            name_th: this.unitForm.name_th,
                            name_en: this.unitForm.name_en
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'index':
                    this.onGetIndex(data).then(() => {
                        this.indexData = {
                            index_code: this.indexForm.index_code,
                            name_th: this.indexForm.name_th,
                            name_en: this.indexForm.name_en,
                            unit_id: this.indexForm.unit_id
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'index-group':
                    let groupIndexArray = [];
                    this.onGetIndexGroup(data).then(() => {
                        this.indexGroupForm.group_index.forEach((item) => {
                            groupIndexArray.push(item.index_id)
                        });
                        this.indexGroupData = {
                            name_th: this.indexGroupForm.name_th,
                            name_en: this.indexGroupForm.name_en,
                            group_index: groupIndexArray
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'report':
                    this.onGetArticle(data).then(() => {
                        // console.log(this.articleForm)
                        let reportCreateDate = this.articleForm.report_create_date.split(' ');
                        this.articleData = {
                            name_th: this.articleForm.name_th,
                            name_en: this.articleForm.name_en,
                            intro_th: this.articleForm.intro_th,
                            intro_en: this.articleForm.intro_en,
                            detail_th: this.articleForm.detail_th,
                            detail_en: this.articleForm.detail_en,
                            split_date: reportCreateDate[0],
                            split_time: reportCreateDate[1].substr(0, 5),
                            indexmanage_id: this.articleForm.indexmanage_id,
                            tag_id: this.articleForm.tag_id,
                            industry_id: this.articleForm.industry_id,
                            image_cover_path: this.articleForm.image_cover_path,
                            image_share_path: this.articleForm.image_share_path,
                            is_display_overview: this.articleForm.is_display_overview
                        };
                        this.fileInput = null;
                        this.shareImgInput = null;
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'users':
                    this.onGetAccount(data).then(() => {
                        this.userAccount = {
                            first_name: this.accountForm.first_name,
                            last_name: this.accountForm.last_name,
                            email: this.accountForm.email,
                            username: this.accountForm.username,
                            password: this.accountForm.password,
                            c_password: ''
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'tag':
                    this.onGetTag(data).then(() => {
                        this.tagData = {
                            name: this.tagForm.name
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'title':
                    this.onGetTopic(data).then(() => {
                        this.topicData = {
                            name_th: this.topicForm.name_th,
                            name_en: this.topicForm.name_en
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                case 'import':
                    // user can't edit
                    break;
                // case 'data-and-stats':
                // case 'cindex':
                //     await Promise.all([
                //         this.populateGraphTypes(),
                //         this.populateStatisticForm(this.param)
                //     ]);
                //     this.drawer = !this.drawer;
                //     break;
                case 'main-menu':
                    this.onGetMainMenu(data).then(() => {
                        this.mainMenuData = {
                            id: this.mainMenuForm.id,
                            name_th: this.mainMenuForm.name_th,
                            name_en: this.mainMenuForm.name_en,
                            src_url: this.mainMenuForm.src_url,
                            status: this.mainMenuForm.status
                        };
                    }).then(() => {
                        this.drawer = !this.drawer;
                    });
                    break;
                default:
                    await Promise.all([
                        this.populateGraphTypes(),
                        this.populateStatisticForm(this.param)
                    ]);
                    this.drawer = !this.drawer;
            }

        },
        async onAddStatistic() {
            await Promise.all([
                this.clearStatisticForm(),
                this.populateGraphTypes()
            ]);
            this.drawer = !this.drawer
        },
        onDelete() {
            let ok = null;
            switch (this.type) {
                case 'tsic':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteTsic(data).then(() => {
                            // close dialog after deleted
                            this.drawer = !this.drawer;
                            this.onGetAllTsicPaginate(data);
                        });
                    }
                    break;

                case 'group':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteIndustry(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllIndustriesPaginate(data);
                        });
                    }
                    break;

                case 'jobs-group':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteJobsGroup(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllJobsGroupPaginate(data);
                        });
                    }
                    break;

                case 'unit':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteUnit(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllUnitPaginate(data);
                        });
                    }
                    break;

                case 'index':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteIndex(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllIndexPaginate(data);
                        });
                    }
                    break;

                case 'index-group':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteIndexGroup(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllIndexGroupPaginate(data);
                        });
                    }
                    break;

                case 'report':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteArticle(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllArticlePaginate(data);
                        });
                    }
                    break;

                case 'users':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteAccount(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllAccountPaginate(data);
                        });
                    }
                    break;

                case 'tag':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteTag(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllTagPaginate(data);
                        });
                    }
                    break;

                case 'title':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteTopic(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllTopicPaginate(data);
                        });
                    }
                    break;

                case 'import':
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let data = { id: this.param, token: this.userData.token };
                        this.onDeleteImported(data).then(() => {
                            this.drawer = !this.drawer;
                            this.onGetAllImportedPaginate(data);
                        });
                    }
                    break;

                default:
                    ok = confirm('ยืนยันการลบข้อมูลลำดับที่ ' + this.param + ' ?');
                    if (ok) {
                        let id = this.param;
                        this.onDeleteStatistic(id).then(() => {
                            this.drawer = !this.drawer;
                            this.populateStatistics();
                        });
                    }
                    break;

            }

        },
        async saveForm() {
            if (this.edit) {
                // edit
                switch (this.type) {
                    case 'tsic':
                        this.tsicData.id = this.param;
                        this.tsicData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditTsic(this.tsicData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllTsicPaginate(this.tsicData);
                            });
                        }
                        break;

                    case 'group':
                        this.groupData.id = this.param;
                        this.groupData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditIndustry(this.groupData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndustriesPaginate(this.groupData);
                            });
                        }
                        break;

                    case 'jobs-group':
                        this.jobsGroup.id = this.param;
                        this.jobsGroup.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditJobsGroup(this.jobsGroup).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllJobsGroupPaginate(this.jobsGroup);
                            });
                        }
                        break;

                    case 'unit':
                        this.unitData.id = this.param;
                        this.unitData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditUnit(this.unitData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllUnitPaginate(this.unitData);
                            });
                        }
                        break;

                    case 'index':
                        this.indexData.id = this.param;
                        this.indexData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditIndex(this.indexData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndexPaginate(this.indexData);
                            });
                        }
                        break;

                    case 'index-group':
                        this.indexGroupData.id = this.param;
                        this.indexGroupData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditIndexGroup(this.indexGroupData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndexGroupPaginate(this.indexGroupData);
                            });
                        }
                        break;

                    case 'report':
                        this.articleData.id = this.param;
                        this.articleData.token = this.userData.token;
                        this.articleData.report_create_date = this.articleData.split_date + ' ' + this.articleData.split_time + ':00';
                        if (this.formIsValid()) {
                            if (this.articleData.image_cover_path === this.articleForm.image_cover_path) {
                                // didn't change image
                                this.articleData.image_cover_path = null;
                            }
                            if (this.articleData.image_share_path === this.articleForm.image_share_path) {
                                // didn't change image
                                this.articleData.image_share_path = null;
                            }
                            this.onEditArticle(this.articleData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllArticlePaginate(this.articleData);
                            });
                        }
                        break;

                    case 'users':
                        this.userAccount.id = this.param;
                        this.userAccount.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditAccount(this.userAccount).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllAccountPaginate(this.userAccount);
                            });
                        }
                        break;

                    case 'tag':
                        this.tagData.id = this.param;
                        this.tagData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditTag(this.tagData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllTagPaginate(this.tagData);
                            });
                        }
                        break;

                    case 'title':
                        this.topicData.id = this.param;
                        this.topicData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditTopic(this.topicData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllTopicPaginate(this.topicData);
                            });
                        }
                        break;

                    case 'import':
                        // user can't edit
                        break;
                    case 'main-menu':
                        this.mainMenuData.id = this.param;
                        this.mainMenuData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onEditMainMenu(this.mainMenuData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetMainMenu(this.mainMenuData);
                            });
                        }
                        break;

                    // case 'data-and-stats':
                    // case 'cindex':
                    //   try {
                    //     await this.saveStatisticForm(this.param);
                    //     alert('แก้ไขข้อมูลสำเร็จ');
                    //     this.drawer = !this.drawer;
                    //   } catch (error) {
                    //     alert('แก้ไขข้อมูลล้มเหลว');
                    //   }
                    //
                    //   this.$emit('save');
                    //     console.log('edit cindex')
                    //   break;

                    default:
                        if (this.formIsValid()) {
                            try {
                                await this.saveStatisticForm(this.param)
                                Swal.fire({
                                    icon: 'success',
                                    title: 'เรียบร้อย!',
                                    text: 'แก้ไขข้อมูลสำเร็จ',
                                })
                                // alert('แก้ไขข้อมูลสำเร็จ');
                                this.drawer = !this.drawer;
                            } catch (error) {
                                console.error({ error })
                                Swal.fire({
                                    icon: 'error',
                                    title: 'ผิดพลาด!',
                                    text: error.response.data.message,
                                })
                                // alert(error.response.data.message);
                            }

                            this.populateStatistics();
                        }

                }
            } else {
                // add
                switch (this.type) {
                    case 'tsic':
                        this.tsicData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateTsic(this.tsicData).then(() => {
                                // clear form after added
                                this.drawer = !this.drawer;
                                this.onGetAllTsicPaginate(this.tsicData);
                                this.tsicData = {
                                    code: '',
                                    name_th: '',
                                    name_en: ''
                                };
                            });
                        }
                        break;

                    case 'group':
                        this.groupData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateIndustry(this.groupData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndustriesPaginate(this.groupData);
                                this.groupData = {
                                    name_th: '',
                                    name_en: '',
                                    industry_tsic: [],
                                    description_th: '',
                                    description_en: '',
                                    icon_path: '',
                                    icon: '',
                                    status: 0
                                };
                                this.iconFileInput = null;
                            });
                        }
                        break;

                    case 'jobs-group':
                        this.jobsGroup.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateJobsGroup(this.jobsGroup).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllJobsGroupPaginate(this.jobsGroup);
                                this.jobsGroup = {
                                    name_th: '',
                                    name_en: ''
                                };
                            });
                        }
                        break;

                    case 'unit':
                        this.unitData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateUnit(this.unitData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllUnitPaginate(this.unitData);
                                this.unitData = {
                                    name_th: '',
                                    name_en: ''
                                };
                            });
                        }
                        break;

                    case 'index':
                        this.indexData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateIndex(this.indexData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndexPaginate(this.indexData);
                                this.indexData = {
                                    index_code: '',
                                    name_th: '',
                                    name_en: '',
                                    unit_id: null
                                };
                            });
                        }
                        break;

                    case 'index-group':
                        this.indexGroupData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateIndexGroup(this.indexGroupData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllIndexGroupPaginate(this.indexGroupData);
                                this.indexGroupData = {
                                    name_th: '',
                                    name_en: '',
                                    group_index: []
                                };
                            });
                        }
                        break;

                    case 'report':
                        this.articleData.token = this.userData.token;
                        this.articleData.report_create_date = this.articleData.split_date + ' ' + this.articleData.split_time + ':00';
                        // console.log(this.articleData.report_create_date);
                        if (this.formIsValid()) {
                            this.onCreateArticle(this.articleData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllArticlePaginate(this.articleData);
                                this.fileInput = null;
                                this.shareImgInput = null;
                                this.articleData = {
                                    name_th: '',
                                    name_en: '',
                                    intro_th: '',
                                    intro_en: '',
                                    detail_th: '',
                                    detail_en: '',
                                    report_create_date: '',
                                    split_date: new Date().toISOString().substr(0, 10),
                                    split_time: new Date().toTimeString().substr(0, 5),
                                    indexmanage_id: null,
                                    tag_id: [],
                                    industry_id: null,
                                    image_cover_path: '',
                                    image_share_path: '',
                                    is_display_overview: 0
                                };
                            });
                        }
                        break;

                    case 'users':
                        this.userAccount.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateAccount(this.userAccount).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllAccountPaginate(this.userAccount);
                                this.userAccount = {
                                    first_name: '',
                                    last_name: '',
                                    email: '',
                                    username: '',
                                    password: '',
                                    c_password: ''
                                };
                            });
                        }
                        break;


                    case 'tag':
                        this.tagData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateTag(this.tagData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllTagPaginate(this.tagData);
                                this.tagData = {
                                    name: ''
                                };
                            });
                        }
                        break;

                    case 'title':
                        this.topicData.token = this.userData.token;
                        if (this.formIsValid()) {
                            this.onCreateTopic(this.topicData).then(() => {
                                this.drawer = !this.drawer;
                                this.onGetAllTopicPaginate(this.topicData);
                                this.topicData = {
                                    name_th: '',
                                    name_en: ''
                                };
                            });
                        }
                        break;

                    case 'import':
                        this.importedData.token = this.userData.token;
                        if (this.formIsValid()) {
                            // Use FormData instead
                            this.sendImportedForm(this.importedData);
                        }
                        break;

                    // case 'data-and-stats':
                    // case 'cindex':
                    //     try {
                    //         await this.saveStatisticForm();
                    //         alert('เพิ่มข้อมูลสำเร็จ');
                    //         this.drawer = !this.drawer;
                    //     } catch (error) {
                    //         alert('เพิ่มข้อมูลล้มเหลว');
                    //     }
                    //
                    //     this.$emit('save');
                    //     break;

                    default:
                        if (this.formIsValid()) {
                            try {
                                await this.saveStatisticForm();
                                Swal.fire({
                                    icon: 'success',
                                    title: 'เรียบร้อย!',
                                    text: 'เพิ่มข้อมูลสำเร็จ',
                                })
                                // alert('เพิ่มข้อมูลสำเร็จ');
                                this.drawer = !this.drawer;
                            } catch (error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'ผิดพลาด!',
                                    text: 'เพิ่มข้อมูลล้มเหลว',
                                })
                                // alert('เพิ่มข้อมูลล้มเหลว');
                            }

                            this.populateStatistics();
                        }



                }

            }
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            var formData = new FormData();
            formData.append("image", file);

            axios({
                url: domain + '/api/add/image',
                method: "POST",
                data: formData,
                headers: { Authorization: `Bearer ${this.userData.token}` }
            }).then(result => {
                let url = domain + '/' + result.data;  // Get url from response
                Editor.insertEmbed(cursorLocation, "image", url);
                resetUploader();
            }).catch(err => {
                console.log(err);
            });

        },
        reportImageAdded(image) {
            // console.log(image)
            if (image === null) {
                console.log("1");
            } else {
                var _this = this;
                var reader = new FileReader();
                reader.readAsDataURL(_this.fileInput);
                reader.onload = function () {
                    _this.articleData.image_cover_path = reader.result;
                    // console.log( _this.articleData.image_cover_path)
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
            }

        },
        reportShareImageAdded(image) {
            // console.log(image)
            if (image === null) {

            } else {
                var _this = this;
                var reader = new FileReader();
                reader.readAsDataURL(_this.shareImgInput);
                reader.onload = function () {
                    _this.articleData.image_share_path = reader.result;
                    // console.log( _this.articleData.image_cover_path)
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
            }

        },
        industryImageAdded(image) {
            // console.log(image)
            if (image === null) {

            } else {
                var _this = this;
                var reader = new FileReader();
                reader.readAsDataURL(_this.iconFileInput);
                reader.onload = function () {
                    _this.groupData.icon = reader.result;
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                };
            }

        },
        sendImportedForm: function (data) {

            // console.log('data: ',data);
            let formData = new FormData();
            formData.append('topic_id', data.topic_id);
            formData.append('index_id', data.index_id);
            formData.append('year_data', data.year_data);
            formData.append('file_path', data.file_path);
            formData.append('name', data.name);
            formData.append('display_status', 0);

            axios({
                url: domain + '/api/import/data',
                method: "POST",
                data: formData,
                headers: { Authorization: `Bearer ${data.token}`, 'Content-Type': 'multipart/form-data' }
            }).then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'เรียบร้อย!',
                    text: 'เพิ่มข้อมูลสำเร็จ',
                })
                // alert('เพิ่มข้อมูลสำเร็จ');
                this.drawer = !this.drawer;
                this.onGetAllImportedPaginate(this.importedData);
                this.importedData = {
                    topic_id: null,
                    index_id: null,
                    year_data: null,
                    file_path: null,
                    display_status: 0,
                    name: ''
                }
            })

        },
        formIsValid() {
            let alertMsg = 'กรุณากรอกข้อมูลจำเป็นให้ครบถ้วน';
            switch (this.type) {
                case 'tsic':
                    if (
                        this.tsicData.code === '' ||
                        this.tsicData.name_th === '' ||
                        this.tsicData.name_en === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })

                        return false
                    } else {
                        return true
                    }
                    break;
                case 'group':
                    if (
                        this.groupData.name_th === '' ||
                        this.groupData.name_en === '' ||
                        this.groupData.industry_tsic.length === 0 ||
                        this.groupData.description_th === '' ||
                        this.groupData.description_en === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'jobs-group':
                    if (
                        this.jobsGroup.name_th === '' ||
                        this.jobsGroup.name_en === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'unit':
                    if (
                        this.unitData.name_th === '' ||
                        this.unitData.name_en === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'index':
                    if (
                        this.indexData.index_code === '' ||
                        this.indexData.name_th === '' ||
                        this.indexData.name_th === '' ||
                        this.indexData.unit_id === null
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'index-group':
                    if (
                        this.indexGroupData.name_th === '' ||
                        this.indexGroupData.name_th === '' ||
                        this.indexGroupData.group_index.length === 0
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'report':
                    if (
                        this.articleData.name_th === '' ||
                        this.articleData.name_en === '' ||
                        this.articleData.intro_th === '' ||
                        this.articleData.intro_en === '' ||
                        this.articleData.detail_th === '' ||
                        this.articleData.detail_en === '' ||
                        this.articleData.indexmanage_id === null ||
                        this.articleData.tag_id.length === 0 ||
                        this.articleData.industry_id === null
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'users':
                    if (this.edit === true) {
                        if (
                            this.userAccount.first_name === '' ||
                            this.userAccount.last_name === '' ||
                            this.userAccount.username === ''
                        ) {
                            Swal.fire({
                                icon: 'warning',
                                text: alertMsg,
                            })
                            return false
                        } else {
                            return true
                        }

                    } else {
                        if (
                            this.userAccount.first_name === '' ||
                            this.userAccount.last_name === '' ||
                            this.userAccount.email === '' ||
                            this.userAccount.username === '' ||
                            this.userAccount.password === '' ||
                            this.userAccount.c_password === ''
                        ) {
                            Swal.fire({
                                icon: 'warning',
                                text: alertMsg,
                            })
                            return false
                        } else {
                            return true
                        }
                    }
                    break;
                case 'tag':
                    if (
                        this.tagData.name === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'title':
                    if (
                        this.topicData.name_th === '' ||
                        this.topicData.name_en === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'import':
                    if (
                        this.importedData.topic_id === null ||
                        this.importedData.index_id === null ||
                        this.importedData.year_data === null ||
                        this.importedData.file_path === null ||
                        this.importedData.name === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                case 'main-menu':
                    if (
                        this.mainMenuData.name_th === '' ||
                        this.mainMenuData.name_en === '' ||
                        this.mainMenuData.src_url === ''
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }
                    break;
                // data-and-stats and cindex
                default:
                    if (
                        this.statisticForm.title_th === '' ||
                        this.statisticForm.title_en === '' ||
                        this.statisticForm.description_th === '' ||
                        this.statisticForm.description_en === '' ||
                        this.statisticForm.caption_th === '' ||
                        this.statisticForm.caption_en === '' ||
                        this.statisticForm.topic_id === null ||
                        this.statisticForm.graph_type_id === null ||
                        this.statisticForm.tags.length === 0
                    ) {
                        Swal.fire({
                            icon: 'warning',
                            text: alertMsg,
                        })
                        return false
                    } else {
                        return true
                    }

            }
        }

    },
    watch: {
        // changingValue: function () {
        //     console.log('article ', this.watchValue);
        // }
    }
}
</script>

<style scoped></style>
